import React,{useState,useEffect} from 'react';
import clsx from 'clsx';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import List from '@material-ui/core/List';
import CssBaseline from '@material-ui/core/CssBaseline';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import InboxIcon from '@material-ui/icons/MoveToInbox';
import MailIcon from '@material-ui/icons/Mail';
// import "../../node_modules/material-design-icons/iconfont/material-icons.css";
// import {navConfig} from '../utils/sidebarData'
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import StarBorder from '@material-ui/icons/StarBorder';
import Collapse from '@material-ui/core/Collapse';
import { Link } from 'react-router-dom';
import Badge from '@material-ui/core/Badge';
import ButtonComponent from '../button/Button'
import { Popover, Paper, Avatar } from '@material-ui/core';
// import Footer from '../footer/footer'
import {GoDashboard} from 'react-icons/go'
import {AiOutlineBarChart} from 'react-icons/ai'
import {MdCompare} from 'react-icons/md'
import {FiLogOut} from 'react-icons/fi'
var jwt = require('jsonwebtoken');


// import logo1 from '../../assets/images/starangiLogo.png'

const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginRight: 36,
  },
  hide: {
    display: "none",
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: "nowrap",
  },
  overflow:{
    textOverflow:'ellipsis',
    whiteSpace:'nowrap',
    overflow:'hidden',
    
  },
  drawerOpen: {
    width: drawerWidth,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerClose: {
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: "hidden",
    width: theme.spacing(11) + 1,
    [theme.breakpoints.up("sm")]: {
      width: theme.spacing(11) + 1,
    },
  },
  toolbar: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
  },
  toolbarDropdown: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    // padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    // ...theme.mixins.toolbar,
  },
  nested: {
    paddingLeft: theme.spacing(6),
  },
  content: {
    
    flexGrow: 1,
    padding: theme.spacing(3,3,0,3),
  },
  large: {
    width: theme.spacing(7),
    height: theme.spacing(7),
  },
  typography: {
    minWidth: 100,
    //minHeight:200,
    padding: theme.spacing(2),
  },
  paddingTB: {
    width: "100%",
    margin: theme.spacing(1, 0, 1, 0),
  },
  marginLR:{
    margin:theme.spacing(0,2,0,2)
  },
  PB:{
    // minHeight:'100vh',
    paddingBottom:theme.spacing(20)
  }
}));

export default function MiniDrawer({ children }) {
  const classes = useStyles();
  const theme = useTheme();
  const [open, setOpen] = React.useState(true);
  const [openList, setOpenList] = React.useState(false);
  const [expandList, setExpandList] = React.useState([]);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [user,setUser]=useState(null)
  const currentPage=window.location.pathname
  const sideBarList=[
    {
      icon:GoDashboard,
      text:'Dashboard',
      route:'/'
    },
    {
      icon:AiOutlineBarChart,
      text:'Details Findings By Outlet',
      route:'/DashboardReports'
    },
    // {
    //   icon:MdCompare,
    //   text:'Comparison',
    //   route:'/Comparison'
    // }
  ]

  const openPopover = Boolean(anchorEl);
  const id = openPopover ? 'simple-popover' : undefined;
  
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const CurrentUserID = () => {
    const data = localStorage.getItem('Auth-Token');
    try {
        return jwt.verify(data,'abcd1234');
    }
    catch(ex){
        return null
    }
  }
  
  React.useEffect(() => {
    const list = []
    // navConfig.forEach(item => list.push(false))
    setExpandList(list)
    setUser(CurrentUserID())
  }, [])

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  const Logout = async()=>{
    const token=localStorage.removeItem('Auth-Token')
    window.open('/login','_self')
  }



  return (
    <div className={classes.root}>
      <CssBaseline />
      <AppBar
        position="fixed"
        className={clsx(classes.appBar, {
          [classes.appBarShift]: open,
        })}
      >
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={handleDrawerOpen}
            edge="start"
            className={clsx(classes.menuButton, {
              [classes.hide]: open,
            })}
          >
            <MenuIcon />
          </IconButton>
          <Typography variant="h6" noWrap>
            Dashboard
          </Typography>
          <span style={{ flex: 1 }} />
          <Typography>{user && user.Name}</Typography>
        </Toolbar>
      </AppBar>
      <Drawer
        variant="permanent"
        className={clsx(classes.drawer, {
          [classes.drawerOpen]: open,
          [classes.drawerClose]: !open,
        })}
        classes={{
          paper: clsx({
            [classes.drawerOpen]: open,
            [classes.drawerClose]: !open,
          }),
        }}
      >
        <div className={classes.toolbar}>
          {/* <span style={{background:`url(${require('../../assets/images/starangiLogo.png')})`,height:"50px",backgroundSize:'cover' ,width:"50px"}}/> */}
          {/* <img src='../../assets/images/starangiLogo.png' style={{backgroundSize:'cover'}} alt="img" height="50px" width="50px"/> */}
          <IconButton onClick={handleDrawerClose}>
            {theme.direction === "rtl" ? (
              <ChevronRightIcon />
            ) : (
              <ChevronLeftIcon />
            )}
          </IconButton>
        </div>
        <Divider />
        <List>

          {
            sideBarList.map(item=>{
              return(
                <Link style={{textDecoration:'none',color:"black"}} to={item.route}>
                  <abbr style={{textDecoration:"none"}} title={item.text}>
                    <ListItem button key={item.text}>
                      <ListItemIcon>
                        <item.icon style={{fontSize:'30px'}}/>
                      </ListItemIcon>
                      <ListItemText className={classes.overflow} color="primary">
                        {item.text}
                      </ListItemText>
                    </ListItem>
                  </abbr>
                </Link>
              )
            })
          }
          
        </List>
        <div style={{position:"absolute",bottom:'10px',width:"100%"}}>
        <Divider style={{width:"100%"}} />
        <List >
          <ListItem onClick={() => Logout()} button key={'Logout'}>
            <ListItemIcon>
                <FiLogOut style={{fontSize:'30px'}}/>
            </ListItemIcon>
              <ListItemText color="primary" primary={"Logout"} />
            </ListItem>
          </List>
          </div>
      </Drawer>
        
      <main className={classes.content}>
        <div className={classes.toolbar} />
        {children}
        <div className={classes.PB}/>
        {/* <Typography paragraph>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt
          ut labore et dolore magna aliqua. Rhoncus dolor purus non enim praesent elementum
          facilisis leo vel. Risus at ultrices mi tempus imperdiet. Semper risus in hendrerit
          gravida rutrum quisque non tellus. Convallis convallis tellus id interdum velit laoreet id
          donec ultrices. Odio morbi quis commodo odio aenean sed adipiscing. Amet nisl suscipit
          adipiscing bibendum est ultricies integer quis. Cursus euismod quis viverra nibh cras.
          Metus vulputate eu scelerisque felis imperdiet proin fermentum leo. Mauris commodo quis
          imperdiet massa tincidunt. Cras tincidunt lobortis feugiat vivamus at augue. At augue eget
          arcu dictum varius duis at consectetur lorem. Velit sed ullamcorper morbi tincidunt. Lorem
          donec massa sapien faucibus et molestie ac.
        </Typography>
        <Typography paragraph>
          Consequat mauris nunc congue nisi vitae suscipit. Fringilla est ullamcorper eget nulla
          facilisi etiam dignissim diam. Pulvinar elementum integer enim neque volutpat ac
          tincidunt. Ornare suspendisse sed nisi lacus sed viverra tellus. Purus sit amet volutpat
          consequat mauris. Elementum eu facilisis sed odio morbi. Euismod lacinia at quis risus sed
          vulputate odio. Morbi tincidunt ornare massa eget egestas purus viverra accumsan in. In
          hendrerit gravida rutrum quisque non tellus orci ac. Pellentesque nec nam aliquam sem et
          tortor. Habitant morbi tristique senectus et. Adipiscing elit duis tristique sollicitudin
          nibh sit. Ornare aenean euismod elementum nisi quis eleifend. Commodo viverra maecenas
          accumsan lacus vel facilisis. Nulla posuere sollicitudin aliquam ultrices sagittis orci a.
        </Typography> */}
        {/* <Footer justify="flex-end">Footer text © 2020</Footer> */}
      </main>
    </div>
  );
}

